import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Minus, Plus, ShoppingBag, ArrowLeft, Lock } from "lucide-react";
import { api, eur } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export default function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const { add } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/products/${id}`).then(({ data }) => setProduct(data)).catch(() => setProduct(false));
  }, [id]);

  if (product === false) return <main className="max-w-7xl mx-auto px-6 py-32 text-center brand-muted">Produto não encontrado.</main>;
  if (!product) return <main className="max-w-7xl mx-auto px-6 py-32 text-center brand-muted">A carregar...</main>;

  return (
    <main className="max-w-7xl mx-auto px-6 lg:px-12 py-12" data-testid="page-product">
      <Link to="/loja" className="inline-flex items-center gap-2 text-sm brand-muted hover:brand-primary-text mb-8">
        <ArrowLeft size={14} /> Voltar à loja
      </Link>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
        <div className="brand-surface aspect-[4/5] overflow-hidden">
          <img src={product.image_url} alt={product.name} className="w-full h-full object-cover" data-testid="product-image" />
        </div>

        <div className="lg:pt-8">
          <p className="label-sm mb-3">{product.category}</p>
          <h1 className="font-serif text-4xl lg:text-5xl brand-text mb-6" data-testid="product-title">{product.name}</h1>
          {user ? (
            <p className="font-serif text-3xl brand-primary-text mb-10" data-testid="product-price">{eur(product.price)}</p>
          ) : (
            <div className="mb-10" data-testid="product-price-locked">
              <Link
                to="/entrar"
                state={{ from: `/produto/${id}` }}
                className="inline-flex items-center gap-2 font-serif text-xl brand-primary-text underline hover:opacity-80"
              >
                <Lock size={16} /> Entrar para ver o preço
              </Link>
            </div>
          )}

          <p className="brand-muted leading-relaxed mb-10" data-testid="product-description">{product.description}</p>

          <div className="space-y-6">
            <div>
              <p className="label-sm mb-3">Quantidade</p>
              <div className="flex items-center gap-3">
                <button onClick={() => setQty(Math.max(1, qty - 1))} className="p-3 brand-border border" data-testid="qty-dec"><Minus size={14} /></button>
                <span className="w-10 text-center" data-testid="qty-display">{qty}</span>
                <button onClick={() => setQty(qty + 1)} className="p-3 brand-border border" data-testid="qty-inc"><Plus size={14} /></button>
              </div>
            </div>

            <button onClick={() => {
              if (product.in_stock === false) return;
              if (!user) { nav("/entrar", { state: { from: `/produto/${id}` } }); return; }
              add(product, qty);
            }} disabled={product.in_stock === false} className="btn-primary w-full" data-testid="btn-add-to-cart">
              {product.in_stock === false ? <><Lock size={16} /> Esgotado</> : user ? <><ShoppingBag size={16} /> Adicionar ao carrinho</> : <><Lock size={16} /> Entrar para comprar</>}
            </button>

            <div className="pt-6 border-t brand-border space-y-2 text-sm brand-muted">
              {product.in_stock === false ? (
                <p style={{ color: "#9E4747" }} data-testid="product-sold-out">· Produto esgotado</p>
              ) : (
                <p data-testid="product-available">· Disponível</p>
              )}
              <p>· Portes calculados no checkout consoante o destino e o peso</p>
              <p>· Levantamento presencial gratuito disponível</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
